var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _g, _circle3, _circle4, _defs, _circle5, _circle6, _g2, _circle7, _circle8, _defs2, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 752,
    height: 100,
    viewBox: "0 0 752 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-close",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    x: 0,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "square",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    stroke: "#000",
    d: "M28 4l-24 24M4 4l24 24"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-entrance",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.789 21.818.325-.554-.325.554Zm-.632-.728-.588.26.588-.26Zm12.686 0-.588-.26.588.26Zm-.632.728-.325-.554.325.554Zm0-19.636.326-.555-.326.555Zm.632.728-.588.26.588-.26Zm-12.686 0-.588-.26.588.26Zm.632-.728-.326-.555.326.555Zm5.956 10.195-.44-.469.44.47Zm0-.754.44-.469-.44.469Zm.238.48.607.21-.607-.21Zm0-.206.607-.21-.607.21Zm-6.34-5.73v-1.5H7.357v1.5h1.286Zm1.668-3.524h8.378V1.357H10.31v1.286Zm10.046 2.024v14.666h1.286V4.667h-1.286Zm-1.668 16.69H10.31v1.286h8.378v-1.286ZM8.643 19.333v-1.5H7.357v1.5h1.286Zm1.668 2.024c-.417 0-.685 0-.888-.02-.193-.018-.267-.049-.309-.073l-.651 1.108c.268.158.55.218.84.245.277.026.616.026 1.008.026v-1.286Zm-2.954-2.024c0 .458 0 .835.021 1.14.022.312.07.601.191.877l1.177-.52c-.036-.08-.068-.203-.085-.447-.018-.25-.018-.574-.018-1.05H7.357Zm1.757 1.931a.933.933 0 0 1-.368-.434l-1.177.52c.188.425.496.788.894 1.022l.651-1.108Zm11.243-1.93c0 .475 0 .799-.018 1.049-.017.244-.049.366-.084.447l1.176.52c.121-.276.168-.566.19-.877.022-.305.022-.682.022-1.14h-1.286Zm-1.668 3.309c.392 0 .73 0 1.009-.026.289-.027.571-.087.84-.245l-.652-1.108c-.042.024-.116.055-.309.073-.204.02-.471.02-.888.02v1.286Zm1.566-1.813a.933.933 0 0 1-.37.434l.652 1.108c.398-.234.706-.597.894-1.022l-1.177-.52ZM18.689 2.643c.417 0 .684 0 .888.02.193.018.267.049.308.073l.652-1.109c-.268-.157-.55-.217-.84-.244-.277-.027-.616-.026-1.008-.026v1.286Zm2.954 2.024c0-.458 0-.834-.021-1.14-.023-.312-.07-.601-.191-.877l-1.177.52c.036.08.068.203.085.447.018.25.018.574.018 1.05h1.286Zm-1.758-1.931c.146.085.28.232.37.434l1.176-.52a2.215 2.215 0 0 0-.894-1.023l-.651 1.109ZM8.643 4.666c0-.475 0-.799.018-1.049.017-.244.049-.366.085-.447l-1.177-.52c-.121.276-.169.565-.19.877-.022.305-.022.682-.022 1.14h1.286Zm1.668-3.309c-.392 0-.73 0-1.009.026-.289.027-.571.087-.84.244l.652 1.109c.042-.024.116-.055.309-.073.203-.02.471-.02.888-.02V1.357ZM8.746 3.17a.933.933 0 0 1 .368-.434l-.651-1.109a2.216 2.216 0 0 0-.894 1.023l1.177.52Zm3.643 12.299 2.796-2.623-.88-.938-2.796 2.623.88.938Zm2.796-4.315-2.796-2.623-.88.938 2.796 2.623.88-.938Zm0 1.692c.063-.059.138-.129.198-.196a.98.98 0 0 0 .207-.337l-1.215-.42c.027-.08.068-.119.055-.105a7.357 7.357 0 0 1-.125.12l.88.938Zm-.88-.754a7.357 7.357 0 0 1 .125.12c.013.014-.027-.026-.055-.105l1.215-.42a.98.98 0 0 0-.207-.337c-.06-.067-.135-.137-.198-.196l-.88.938Zm1.285.221a.957.957 0 0 0 0-.626l-1.215.42a.328.328 0 0 1 0-.214l1.215.42Zm-.798-.956H2v1.286h12.792v-1.286Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-exit",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.211 21.819-.325-.555.325.555Zm.632-.729.588.26-.588-.26Zm-12.686 0 .589-.26-.589.26Zm.632.729.325-.555-.325.555Zm0-19.637-.326-.554.326.554Zm-.632.728.589.26-.589-.26Zm12.686 0 .588-.26-.588.26Zm-.632-.728.326-.554-.326.554Zm6.534 10.195-.44-.469.44.47Zm0-.754.44-.469-.44.47Zm.238.48.607.21-.607-.21Zm0-.206.607-.21-.607.21Zm-5.34-5.73v-1.5h-1.286v1.5h1.286Zm-2.954-4.81H5.31v1.286h8.378V1.357ZM2.357 4.667v14.667h1.286V4.667H2.357Zm2.954 17.976h8.378v-1.286H5.31v1.286Zm11.332-3.31v-1.5h-1.286v1.5h1.286Zm-2.954 3.31c.392 0 .73 0 1.009-.025.289-.028.571-.088.84-.245l-.652-1.109c-.042.025-.116.055-.309.073-.204.02-.471.02-.888.02v1.286Zm1.668-3.31c0 .477 0 .8-.018 1.05-.017.245-.049.367-.085.448l1.177.519c.121-.276.168-.565.19-.876.022-.306.022-.683.022-1.14h-1.286Zm.18 3.04c.398-.234.706-.598.894-1.023l-1.177-.52a.933.933 0 0 1-.368.434l.651 1.109Zm-13.18-3.04c0 .458 0 .835.021 1.14.022.312.07.602.191.877l1.177-.52c-.036-.08-.068-.202-.085-.447-.018-.25-.018-.573-.018-1.05H2.357Zm2.954 2.024c-.417 0-.685 0-.888-.02-.193-.018-.267-.048-.309-.073l-.651 1.109c.268.157.55.217.84.245.277.026.616.025 1.008.025v-1.286ZM2.57 21.35c.188.425.496.789.894 1.023l.651-1.109a.932.932 0 0 1-.368-.433l-1.177.519ZM5.311 1.357c-.392 0-.73 0-1.009.026-.289.027-.571.087-.84.245l.652 1.108c.042-.024.116-.055.309-.073.203-.02.471-.02.888-.02V1.357Zm-1.668 3.31c0-.476 0-.8.018-1.05.017-.244.049-.366.085-.447l-1.177-.52c-.121.276-.169.566-.19.877-.022.306-.022.682-.022 1.14h1.286Zm-.18-3.04a2.216 2.216 0 0 0-.894 1.024l1.177.519a.933.933 0 0 1 .368-.434l-.651-1.108Zm13.18 3.04c0-.458 0-.834-.021-1.14-.023-.311-.07-.601-.191-.876l-1.177.519c.036.081.068.203.085.448.018.25.018.573.018 1.049h1.286Zm-2.954-2.024c.417 0 .684 0 .888.02.193.018.267.049.309.073l.651-1.108c-.268-.158-.55-.218-.84-.245-.277-.026-.616-.026-1.008-.026v1.286Zm2.742.008a2.215 2.215 0 0 0-.894-1.023l-.652 1.108c.146.086.28.232.37.434l1.176-.52Zm2.958 12.818 2.796-2.623-.88-.938-2.796 2.623.88.938Zm2.796-4.315-2.796-2.623-.88.938 2.796 2.623.88-.938Zm0 1.692c.063-.058.138-.129.198-.195a.978.978 0 0 0 .207-.337l-1.215-.421c.027-.08.067-.119.055-.105a.907.907 0 0 1-.04.04l-.085.08.88.938Zm-.88-.754c.037.034.063.06.086.08a.907.907 0 0 1 .04.04c.011.014-.029-.025-.056-.104l1.215-.421a.978.978 0 0 0-.207-.337c-.06-.067-.136-.137-.198-.196l-.88.938Zm1.285.222a.957.957 0 0 0 0-.627l-1.215.42a.328.328 0 0 1 0-.214l1.215.42Zm-.798-.957H9v1.286h12.792v-1.286Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-upload",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    x: 96,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#94a3b8",
    strokeLinejoin: "round",
    strokeLinecap: "square",
    strokeMiterlimit: 4,
    strokeWidth: 2.4,
    d: "M10.75 10.25l5.25-5.25 5.25 5.25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#94a3b8",
    d: "M14.8 19v1.2h2.4v-1.2h-2.4zM17.2 5c0-0.663-0.537-1.2-1.2-1.2s-1.2 0.537-1.2 1.2v0h2.4zM17.2 19v-14h-2.4v14h2.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#94a3b8",
    strokeLinejoin: "round",
    strokeLinecap: "square",
    strokeMiterlimit: 4,
    strokeWidth: 2.4,
    d: "M27 19v7c0 0 0 0.001 0 0.002 0 0.551-0.447 0.998-0.998 0.998-0.001 0-0.001 0-0.002 0h-20c-0.552 0-1-0.448-1-1v0-7"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-check",
    width: 10,
    height: 7,
    viewBox: "0 0 38 32",
    x: 5,
    y: 7,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 6.4,
    stroke: "#000",
    d: "M4.266 18.134l8.534 8.534 21.334-21.334"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-geo",
    width: 36,
    height: 36,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m29.733 13.1.74.125v-.001l-.74-.123Zm-5.059 7.019-.406-.63-.01.005-.008.007.424.618Zm-.738.229v-.75.75Zm-.738-.23-.439.609.007.005.007.005.425-.618Zm-5.18-8.39h-.75.75Zm6.19-5.93-.031.749h.012l.02-.75Zm4.668 13.244c0 6.213-5.037 11.25-11.25 11.25v1.5c7.042 0 12.75-5.709 12.75-12.75h-1.5Zm-11.25 11.25c-6.213 0-11.25-5.037-11.25-11.25h-1.5c0 7.041 5.708 12.75 12.75 12.75v-1.5Zm-11.25-11.25c0-6.214 5.037-11.25 11.25-11.25v-1.5c-7.042 0-12.75 5.708-12.75 12.75h1.5Zm11.248 11.25c-.492 0-1.017-.222-1.559-.737-.545-.518-1.07-1.304-1.527-2.333-.913-2.055-1.497-4.946-1.497-8.18h-1.5c0 3.393.61 6.502 1.627 8.79.508 1.143 1.132 2.114 1.863 2.81.735.7 1.613 1.15 2.593 1.15v-1.5Zm-4.583-11.25c0-3.234.584-6.126 1.498-8.181.457-1.028.982-1.814 1.526-2.333.541-.515 1.067-.736 1.56-.736v-1.5c-.981 0-1.859.45-2.594 1.15-.73.695-1.355 1.667-1.863 2.81-1.017 2.288-1.627 5.396-1.627 8.79h1.5Zm9.038 2.591c-.262 2.603-.908 4.832-1.762 6.385-.876 1.593-1.846 2.274-2.693 2.274v1.5c1.692 0 3.053-1.314 4.008-3.052.977-1.777 1.663-4.216 1.94-6.956l-1.493-.15ZM5.7 19.792h11.964v-1.5H5.7v1.5Zm23.293-6.816c-.575 3.413-3.336 5.617-4.725 6.512l.813 1.261c1.477-.952 4.707-3.461 5.392-7.524l-1.48-.25ZM24.25 19.5a.554.554 0 0 1-.314.097v1.5c.415 0 .82-.126 1.163-.361l-.85-1.236Zm-.314.097a.554.554 0 0 1-.313-.097l-.85 1.236c.343.235.748.36 1.163.36v-1.5Zm-.3-.087c-.755-.546-1.987-1.552-3.024-2.907-1.039-1.357-1.843-3.013-1.843-4.876h-1.5c0 2.306.995 4.276 2.151 5.787 1.158 1.513 2.515 2.617 3.34 3.212l.877-1.216Zm-4.867-7.783c0-.7.142-1.392.417-2.035l-1.38-.59a6.688 6.688 0 0 0-.538 2.624l1.5.001Zm.417-2.035a5.189 5.189 0 0 1 1.182-1.709L19.33 6.901a6.688 6.688 0 0 0-1.524 2.203l1.38.589Zm1.182-1.709a5.188 5.188 0 0 1 1.757-1.108l-.53-1.403a6.689 6.689 0 0 0-2.265 1.428l1.038 1.083Zm1.757-1.108a5.19 5.19 0 0 1 2.052-.33l.063-1.498a6.689 6.689 0 0 0-2.644.425l.53 1.403Zm2.064-.329c3.097.081 5.348 3.17 4.804 6.43l1.48.247c.665-3.991-2.074-8.067-6.245-8.176l-.04 1.499ZM22.421 9.5h3v3h-3z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-diagonalLines",
    width: 17,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m1.445 11.168 15-10M1.445 18.168l15-10M1.445 25.168l15-10M1.445 32.168l15-10M1.445 39.168l15-10"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-mobileDiagonalLines",
    viewBox: "0 0 276 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M3.503 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M16.714 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M29.925 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M43.138 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M56.35 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M69.566 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M82.777 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M95.988 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M109.201 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M122.412 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M135.623 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M148.834 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M162.046 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M175.259 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M188.47 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M201.686 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M214.897 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M228.108 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M241.322 1.398l18.135 29.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.6258,
    d: "M254.533 1.398l18.135 29.538"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "npLogo",
    viewBox: "0 0 129 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#da291c",
    style: {
      fill: "var(--color1, #da291c)"
    },
    d: "M18.201 22.29v-4.412h-3.786v4.412h-2.895l3.511 3.479c0.328 0.324 0.779 0.524 1.276 0.524s0.949-0.2 1.277-0.524l-0 0 3.512-3.479h-2.895zM9.627 20.415v-9.485l-3.512 3.478c-0.327 0.322-0.529 0.77-0.529 1.264s0.202 0.942 0.529 1.264l0 0 3.512 3.478zM14.415 9.055v4.412h3.785v-4.412h2.895l-3.512-3.478c-0.328-0.324-0.779-0.524-1.276-0.524s-0.949 0.2-1.277 0.524l0-0-3.51 3.478h2.895zM26.5 14.408l-3.512-3.478v9.485l3.512-3.478c0.327-0.322 0.529-0.77 0.529-1.264s-0.203-0.942-0.529-1.264l-0-0zM37.545 22.53c-1.648 0-3.004-0.359-4.067-1.075s-1.746-1.735-2.050-3.058h3.156c0.39 1.020 1.4 1.53 3.026 1.53 0.824 0 1.475-0.13 1.952-0.391 0.477-0.26 0.716-0.586 0.716-0.976 0-0.456-0.228-0.792-0.683-1.009-0.456-0.217-1.29-0.39-2.505-0.52-3.493-0.391-5.239-1.736-5.239-4.035 0-1.15 0.51-2.082 1.53-2.798s2.342-1.074 3.969-1.074c1.648 0 3.004 0.358 4.067 1.074s1.703 1.692 1.92 2.928h-3.384c-0.174-0.434-0.488-0.76-0.944-0.976-0.455-0.239-1.020-0.358-1.692-0.358-0.802 0-1.42 0.12-1.854 0.358-0.412 0.217-0.619 0.52-0.619 0.911 0 0.412 0.217 0.716 0.651 0.911s1.204 0.347 2.31 0.456c1.866 0.173 3.254 0.596 4.165 1.268s1.367 1.606 1.367 2.799c0 1.214-0.543 2.19-1.627 2.928-1.063 0.738-2.451 1.106-4.165 1.106zM45.44 8.993h2.733v4.588h0.195c0.304-0.348 0.705-0.63 1.204-0.846 0.44-0.202 0.954-0.322 1.495-0.326h0.002c1.193 0 2.147 0.39 2.863 1.172 0.738 0.78 1.106 1.81 1.106 3.090v5.662h-2.765v-5.076c0-0.716-0.174-1.269-0.521-1.66s-0.835-0.585-1.464-0.585c-0.608 0-1.117 0.217-1.53 0.65-0.39 0.435-0.585 0.966-0.585 1.595v5.076h-2.733v-13.339zM62.15 22.529c-0.997 0-1.898-0.217-2.7-0.65-0.784-0.441-1.422-1.058-1.874-1.801l-0.013-0.022c-0.456-0.78-0.684-1.648-0.684-2.603 0-0.954 0.228-1.81 0.684-2.57 0.453-0.774 1.094-1.394 1.862-1.81l0.025-0.012c0.802-0.456 1.703-0.683 2.7-0.683s1.898 0.227 2.701 0.683c0.793 0.428 1.434 1.048 1.875 1.8l0.012 0.022c0.477 0.76 0.716 1.616 0.716 2.57 0 0.955-0.239 1.823-0.716 2.603-0.465 0.764-1.103 1.381-1.862 1.809l-0.025 0.013c-0.803 0.434-1.703 0.651-2.7 0.651zM59.645 17.453c0 0.673 0.239 1.248 0.716 1.725 0.428 0.442 1.026 0.716 1.689 0.716 0.012 0 0.024-0 0.037-0l-0.002 0c0.716 0 1.323-0.228 1.822-0.684 0.5-0.455 0.749-1.040 0.749-1.757 0-0.694-0.25-1.28-0.749-1.756-0.477-0.478-1.063-0.716-1.757-0.716s-1.29 0.238-1.79 0.716c-0.476 0.477-0.715 1.062-0.715 1.756zM69.52 12.573h2.603v1.009h0.195c0.347-0.37 0.77-0.651 1.269-0.846 0.47-0.205 1.018-0.325 1.593-0.326h0.001c1.367 0 2.484 0.477 3.351 1.432s1.302 2.158 1.302 3.611c0 1.454-0.434 2.658-1.302 3.612-0.867 0.954-1.984 1.432-3.351 1.432-0.54-0.003-1.054-0.11-1.524-0.303l0.027 0.010c-0.483-0.204-0.894-0.491-1.235-0.845l-0.001-0.001h-0.195v4.555h-2.733v-13.34zM72.155 17.453c0 0.738 0.228 1.345 0.683 1.823 0.478 0.477 1.063 0.715 1.757 0.715s1.28-0.238 1.757-0.715c0.477-0.5 0.716-1.107 0.716-1.823 0-0.715-0.239-1.312-0.716-1.79-0.428-0.46-1.037-0.747-1.713-0.747-0.015 0-0.031 0-0.046 0l0.002-0c-0.694 0-1.28 0.238-1.757 0.715-0.455 0.478-0.683 1.085-0.683 1.822zM81.89 12.573h2.603v1.009h0.195c0.347-0.37 0.77-0.651 1.27-0.846 0.47-0.205 1.018-0.325 1.593-0.326h0.001c1.366 0 2.483 0.477 3.351 1.432s1.301 2.158 1.301 3.611c0 1.454-0.433 2.658-1.301 3.612s-1.985 1.432-3.351 1.432c-0.54-0.003-1.054-0.11-1.524-0.303l0.027 0.010c-0.483-0.205-0.894-0.491-1.235-0.845l-0.001-0.001h-0.196v4.555h-2.733v-13.34zM84.526 17.453c0 0.738 0.228 1.345 0.683 1.823 0.477 0.477 1.063 0.715 1.757 0.715s1.28-0.238 1.757-0.715c0.477-0.5 0.716-1.107 0.716-1.823 0-0.715-0.239-1.312-0.716-1.79-0.428-0.46-1.037-0.747-1.713-0.747-0.015 0-0.031 0-0.046 0l0.002-0c-0.694 0-1.28 0.238-1.757 0.715-0.456 0.478-0.683 1.085-0.683 1.822zM94.261 12.573h2.733v9.761h-2.733v-9.761zM94.228 8.376h2.799v2.538h-2.799v-2.538zM99.81 12.573h2.603v1.009h0.195c0.326-0.348 0.738-0.63 1.237-0.846 0.46-0.203 0.997-0.322 1.561-0.326h0.001c1.236 0 2.212 0.38 2.928 1.139 0.716 0.76 1.074 1.8 1.074 3.124v5.661h-2.766v-5.14c0-1.497-0.629-2.246-1.887-2.246-0.607 0-1.128 0.228-1.562 0.683-0.402 0.388-0.651 0.931-0.651 1.533 0 0.010 0 0.020 0 0.031l-0-0.002v5.141h-2.733v-9.761zM112.455 23.505h5.824c0.369 0 0.553-0.184 0.553-0.553v-1.985h-0.195c-0.347 0.326-0.77 0.597-1.269 0.814-0.432 0.185-0.936 0.292-1.464 0.293h-0c-1.367 0-2.484-0.456-3.352-1.367-0.867-0.933-1.301-2.093-1.301-3.481 0-1.367 0.434-2.506 1.301-3.417 0.868-0.932 1.985-1.399 3.352-1.399 0.542 0 1.063 0.109 1.561 0.326 0.521 0.195 0.955 0.477 1.302 0.846h0.195v-1.010h2.603v10.933c0 0.738-0.217 1.323-0.651 1.757s-1.019 0.651-1.757 0.651h-6.702v-2.408zM114.017 17.323c0 0.694 0.238 1.28 0.715 1.757 0.478 0.456 1.063 0.684 1.757 0.684s1.269-0.228 1.725-0.684c0.477-0.477 0.716-1.063 0.716-1.757 0-0.672-0.239-1.236-0.716-1.692-0.428-0.441-1.026-0.715-1.688-0.715-0.013 0-0.026 0-0.039 0l0.002-0c-0.694 0-1.279 0.238-1.757 0.715-0.441 0.411-0.716 0.995-0.716 1.643 0 0.017 0 0.034 0.001 0.051l-0-0.003z"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "circleStep",
    width: 49,
    height: 46,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 23.004,
    r: 22.25,
    fill: "#fff",
    stroke: "#DA291C",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 23.004,
    r: 19.5,
    fill: "#DA291C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 23.004,
    r: 14.5,
    fill: "#fff"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 22.504,
    r: 1.75,
    fill: "#fff",
    stroke: "#DA291C",
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 22.504,
    r: 1.75,
    fill: "#fff",
    stroke: "#DA291C",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 31.266,
    height: 32.022,
    x: 8.867,
    y: 8.504,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.567
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1423_2075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1423_2075",
    result: "shape"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "circleStepGrey",
    width: 49,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 22.492,
    r: 22.25,
    fill: "#fff",
    stroke: "#E2E8F0",
    strokeWidth: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 22.492,
    r: 19.5,
    fill: "#E2E8F0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 22.492,
    r: 14.5,
    fill: "#fff"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 21.992,
    r: 1.717,
    fill: "#fff",
    stroke: "#E2E8F0",
    strokeWidth: 0.567
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 21.992,
    r: 1.717,
    fill: "#fff",
    stroke: "#E2E8F0",
    strokeWidth: 0.567
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 31.266,
    height: 32.022,
    x: 8.867,
    y: 7.992,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.567
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1423_2637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1423_2637",
    result: "shape"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-checkInCircle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2eba77",
    style: {
      stroke: "var(--color1, #2eba77)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M12 16l2.667 2.667 5.333-5.333M28 16c0 6.627-5.373 12-12 12s-12-5.373-12-12v0c0-6.627 5.373-12 12-12s12 5.373 12 12v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-closeEye",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#94a3b8",
    style: {
      stroke: "var(--color1, #94a3b8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M13.836 13.173c-0.799 0.734-1.298 1.784-1.298 2.95 0 2.21 1.791 4.001 4.001 4.001 1.166 0 2.216-0.499 2.948-1.295l0.003-0.003M14.969 6.773c0.561-0.069 1.127-0.107 1.693-0.107 9.333 0 13.333 9.333 13.333 9.333-0.643 1.362-1.386 2.536-2.253 3.606l0.026-0.033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#94a3b8",
    style: {
      stroke: "var(--color1, #94a3b8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M9.48 8.813c-2.637 1.813-4.73 4.239-6.1 7.079l-0.047 0.108s4 9.333 13.333 9.333c0.010 0 0.023 0 0.035 0 2.663 0 5.139-0.802 7.199-2.176l-0.047 0.030M3.333 2.667l26.667 26.667"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-openEye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#94a3b8",
    style: {
      stroke: "var(--color1, #94a3b8)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M14.303 6.773c0.56-0.069 1.127-0.107 1.693-0.107 9.333 0 13.333 9.333 13.333 9.333-0.643 1.362-1.386 2.536-2.253 3.606l0.026-0.033M8.813 8.813c-2.637 1.813-4.73 4.239-6.1 7.079l-0.047 0.108s4 9.333 13.333 9.333c0.010 0 0.023 0 0.035 0 2.663 0 5.139-0.802 7.199-2.176l-0.047 0.030"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94a3b8",
    style: {
      fill: "var(--color1, #94a3b8)"
    },
    d: "M20.667 16c0 2.946-2.388 5.333-5.333 5.333s-5.333-2.388-5.333-5.333c0-2.946 2.388-5.333 5.333-5.333s5.333 2.388 5.333 5.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-copy",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#475569",
    style: {
      stroke: "var(--color1, #475569)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M26.667 12h-12c-1.473 0-2.667 1.194-2.667 2.667v0 12c0 1.473 1.194 2.667 2.667 2.667v0h12c1.473 0 2.667-1.194 2.667-2.667v0-12c0-1.473-1.194-2.667-2.667-2.667v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#475569",
    style: {
      stroke: "var(--color1, #475569)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M8 20h-2.667c-1.473 0-2.667-1.194-2.667-2.667v0-12c0-1.473 1.194-2.667 2.667-2.667v0h12c1.473 0 2.667 1.194 2.667 2.667v0 2.667"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-infoCompany",
    width: 25,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA291C",
    d: "M17.5 11a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6Zm0 11.333a5.333 5.333 0 1 1 0-10.666 5.333 5.333 0 0 1 0 10.666Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA291C",
    d: "M17.5 16a1.334 1.334 0 1 0 0-2.667 1.334 1.334 0 0 0 0 2.667Zm0-2a.666.666 0 1 1 0 1.332.666.666 0 0 1 0-1.332ZM17.5 16.667A2.337 2.337 0 0 0 15.167 19v2.333a.333.333 0 1 0 .667 0V19a1.667 1.667 0 0 1 3.333 0v2.333a.333.333 0 1 0 .667 0V19a2.337 2.337 0 0 0-2.334-2.333Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA291C",
    stroke: "#DA291C",
    strokeWidth: 0.2,
    d: "M1.833 23h12a.333.333 0 1 0 0-.667h-4V1.667H22.5v10.666a.333.333 0 1 0 .667 0v-11A.333.333 0 0 0 22.833 1H9.5a.333.333 0 0 0-.333.333v8H3.5a.333.333 0 0 0-.333.334v1.666H1.833a.333.333 0 0 0-.333.334v11a.334.334 0 0 0 .333.333Zm2-13h5.334v1.333H3.833V10Zm-1.666 2h7v10.333h-7V12Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA291C",
    d: "M4.5 12.667H3.166a.333.333 0 0 0-.333.333v1.333a.333.333 0 0 0 .333.334H4.5a.33.33 0 0 0 .308-.206.333.333 0 0 0 .025-.128V13a.333.333 0 0 0-.333-.333ZM4.166 14H3.5v-.667h.666V14ZM7.834 12.667H6.5a.333.333 0 0 0-.333.333v1.333a.333.333 0 0 0 .333.334h1.334a.33.33 0 0 0 .308-.206.333.333 0 0 0 .025-.128V13a.333.333 0 0 0-.333-.333ZM7.5 14h-.666v-.667H7.5V14ZM4.5 15.333H3.166a.33.33 0 0 0-.308.206.333.333 0 0 0-.025.128V17a.333.333 0 0 0 .333.333H4.5A.333.333 0 0 0 4.833 17v-1.333a.333.333 0 0 0-.333-.334Zm-.334 1.334H3.5V16h.666v.667ZM7.834 15.333H6.5a.33.33 0 0 0-.308.206.333.333 0 0 0-.025.128V17a.333.333 0 0 0 .333.333h1.334A.333.333 0 0 0 8.167 17v-1.333a.333.333 0 0 0-.333-.334ZM7.5 16.667h-.666V16H7.5v.667ZM4.5 18H3.166a.334.334 0 0 0-.333.333v1.334a.334.334 0 0 0 .333.333H4.5a.334.334 0 0 0 .333-.333v-1.334A.334.334 0 0 0 4.5 18Zm-.334 1.333H3.5v-.666h.666v.666ZM7.834 18H6.5a.334.334 0 0 0-.333.333v1.334A.334.334 0 0 0 6.5 20h1.334a.334.334 0 0 0 .333-.333v-1.334A.334.334 0 0 0 7.834 18ZM7.5 19.333h-.666v-.666H7.5v.666ZM14.833 3.333a.33.33 0 0 0-.205-.308A.333.333 0 0 0 14.5 3h-2.667a.334.334 0 0 0-.333.333V6a.334.334 0 0 0 .333.333H14.5A.333.333 0 0 0 14.833 6V3.333Zm-.666 2.334h-2v-2h2v2ZM20.833 3.333a.33.33 0 0 0-.205-.308A.333.333 0 0 0 20.5 3h-2.667a.334.334 0 0 0-.333.333V6a.334.334 0 0 0 .333.333H20.5A.333.333 0 0 0 20.833 6V3.333Zm-.666 2.334h-2v-2h2v2ZM14.5 7.667h-2.667A.334.334 0 0 0 11.5 8v2.667a.334.334 0 0 0 .333.333H14.5a.335.335 0 0 0 .333-.333V8a.33.33 0 0 0-.205-.308.333.333 0 0 0-.128-.025Zm-.333 2.666h-2v-2h2v2ZM20.5 11a.335.335 0 0 0 .333-.333V8a.33.33 0 0 0-.205-.308.333.333 0 0 0-.128-.025h-2.667A.334.334 0 0 0 17.5 8v2a.333.333 0 1 0 .667 0V8.333h2v2.334a.33.33 0 0 0 .205.308c.04.017.084.025.128.025Z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrowBack",
    viewBox: "0 0 40 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#475569",
    style: {
      fill: "var(--color1, #475569)"
    },
    d: "M36.5 14h2v4h-2v-4zM3.5 18c-1.105 0-2-0.895-2-2s0.895-2 2-2v0 4zM12.586 2.586l1.414-1.414 2.828 2.828-1.414 1.414-2.828-2.828zM2 16l-1.414 1.414c-0.362-0.362-0.586-0.862-0.586-1.414s0.224-1.052 0.586-1.414v0l1.414 1.414zM15.414 26.586l1.414 1.414-2.828 2.828-1.414-1.414 2.828-2.828zM36.5 18h-33v-4h33v4zM15.414 5.414l-12 12-2.828-2.828 12-12 2.828 2.828zM3.414 14.586l12 12-2.828 2.828-12-12 2.828-2.828z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-linkArrow",
    viewBox: "0 0 30 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#475569",
    style: {
      stroke: "var(--color1, #475569)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.8235,
    d: "M10.353 27.294l8.64-7.974c1.248-1.154 1.873-1.73 2.103-2.406 0.097-0.273 0.152-0.587 0.152-0.915s-0.056-0.642-0.158-0.935l0.006 0.020c-0.23-0.676-0.855-1.252-2.104-2.404l-8.638-7.976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.2bcc97021a0452d753ffa521177c4e73.svg";
export { ForwardRef as ReactComponent };